export default __webpack_public_path__ + "static/media/societree.d8dcaec3.png";